import axios, { AxiosError, AxiosResponse } from 'axios';
import {ToastFailureMessage} from "../Models/Models";
import {showToast} from "../Contexts";

const config = require('../config.json');

// Create a single, shared Axios instance for the entire app
const axiosInstance = axios.create({
    baseURL: process.env.NODE_ENV === 'development' ? config.localUrl : config.serverUrl,
    //baseURL: process.env.NODE_ENV = config.serverUrl,
    withCredentials: true,
});

// Map certain HTTP status codes to frontend routes
const getRedirectPath = (statusCode: number): string | null => {
    const statusCodeRedirects: Record<number, string> = {
        401: '/401',
    };
    return statusCodeRedirects[statusCode] ?? null;
};

// Perform redirect if needed
const handleRedirection = (statusCode: number): void => {
    if (statusCode === 401) {
        return;
    }
    const redirectPath = getRedirectPath(statusCode);
    if (redirectPath) {
        window.location.href = redirectPath;
    }
};

// Attach a global response interceptor for error handling & redirects
const setupInterceptors = (): void => {

    axiosInstance.interceptors.response.use(
        (response: AxiosResponse) => response,
        (error: AxiosError) => {
            const { response, config: requestConfig } = error;

            if (response) {
                if (
                    (response.status === 401 || response.status === 404) &&
                    requestConfig?.url === '/Authorization/login'
                ) {
                    return Promise.reject(error);
                }

                // Don't redirect for missing images
                if (response.status === 404 && requestConfig?.url === '/Image') {
                    return Promise.reject(error);
                }

                // Log error and perform redirect if configured
                console.error('API Error:', response);
                handleRedirection(response.status);
            } else {
                // Network or unexpected error
                showToast?.({ message: ToastFailureMessage.networkError });
                console.error('Network or unexpected error:', error);
            }

            return Promise.reject(error);
        }
    );
};

// Initialize interceptors on import
setupInterceptors();

export default axiosInstance;